import { html } from 'lit';
import { RefreshCcw } from 'lucide-static';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import { state } from 'lit/decorators.js';
import { pdsCustomIconElement as customElement } from '../../../decorators/pds-icon';
import { PdsIcon } from '../PdsIcon';

@customElement('pds-icon-refresh-ccw')
export class PdsIconRefreshCcw extends PdsIcon {
  @state()
  icon = RefreshCcw;

  render() {
    return html`${unsafeHTML(this.setIconAttributes())}`;
  }
}
